import React, { Component } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import './style.scss';

import PageTitle from '../../../components/common/PageTitle';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import FeatherIcon from 'feather-icons-react';
import {
  FormCheckbox,
  FormSelect
} from 'shards-react';

@inject(({ common }) => ({ getDoc: common.getDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ product }) => ({
  getProductList: product.getProductList,
  updateProductReviewConfig: product.updateProductReviewConfig
}))

@observer
class ReviewWriteConfigByProduct extends Component {

  // basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  // list
  @observable listParams = { page: 1, limit: 20 };
  @observable searchParams = {
    keyword: '',
    overReviewCount: '',
  };
  @observable list = [];

  @observable categories = [];

  constructor(props) {
    super(props);
    this.init();
  }

  @action
  init = async () => {
    if (this.props.isLogin) {
      let _this = this;
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.permissions = this.props.me.permissions;

      this.props.getDoc('getCategories', {
        store_id: this.teamUser.selStore_id,
        shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1
      }, function (res) {
        _this.categories = res.data.categoriesData ? res.data.categoriesData : [];
      });

      this.listParams.store_id = this.teamUser.selStore_id;
      this.listParams.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;

      // url params
      for (const key of this.urlParams.keys()) {
        if (['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
          this.listParams[key] = parseInt(this.urlParams.get(key));
        } else {
          this.searchParams[key] = this.urlParams.get(key);
        }
      }

      this.getProductList();
    }
  };

  getProductList = async () => {
    if (this.listParams.store_id) {
      this.listParams.searchParams = this.searchParams;
      this.list = await this.props.getProductList(this.listParams);
      this.isLoading = false;
    }
  };

  search = () => {
    let urlParams = new URLSearchParams();
    for (let key in this.searchParams) {
      if (key !== 'store_id' && key !== 'teamUserId' && key !== 'limit' && this.searchParams[key]) {
        urlParams.set(key, this.searchParams[key]);
      }
    }
    window.location.search = urlParams.toString();
  };

  onChangeSearchValue = (event) => {
    const { name, value } = event.target;
    this.searchParams[name] = value;
  };

  @action
  resetSearchFilters = () => {
    this.searchParams.category = '';
    this.searchParams.keyword = '';
    this.searchParams.overReviewCount = '';
    this.search();
  };

  @action
  clearSearchFilter = (key) => {
    this.searchParams[key] = '';
    this.search();
  };

  // 리뷰 작성 불가 토글
  toggleReviewWriteDisabled = (item) => {
    const cur = !!(item.vr_productReviewConfig && item.vr_productReviewConfig.isReviewWriteDisabled);
    const next = !cur;
    const params = {
      store_id: this.store._id,
      product_id: item._id,
      isReviewWriteDisabled: next
    };
    this.props.updateProductReviewConfig(params, (res) => {
      if (res && res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message || '저장에 실패했습니다.');
        return;
      }
      // 즉시 로컬 반영
      if (!item.vr_productReviewConfig) item.vr_productReviewConfig = {};
      item.vr_productReviewConfig.isReviewWriteDisabled = next;
      toast.success(next ? '해당 상품의 리뷰 작성이 차단되었습니다.' : '해당 상품의 리뷰 작성이 다시 허용되었습니다.');
    });
  };

  render() {
    let _this = this;

    function Pagination() {
      let result = [];
      let totalPages, curPageNum, startNum, endNum;
      if (_this.list && _this.list.totalPages) {
        totalPages = _this.list.totalPages;
        curPageNum = _this.list.page;
        startNum = (parseInt((curPageNum - 1) / 10) * 10) + 1;
        endNum = startNum + 9 < totalPages ? startNum + 9 : totalPages;
      }

      let urlParamsArr = new URLSearchParams(window.location.search);
      urlParamsArr.delete('page');
      let urlParams = '?' + urlParamsArr.toString();

      const rendering = () => {
        for (let i = startNum; i <= endNum; i++) {
          if (i === curPageNum) {
            result.push(<li key={i} className="on"><a href={urlParams + '&page=' + i}>{i}</a></li>);
          } else {
            result.push(<li key={i}><a href={urlParams + '&page=' + i}>{i}</a></li>);
          }
        }
        return result;
      };

      if (_this.list && _this.list.totalPages) {
        return (
          <div className="pagination">
            <ul>
              {curPageNum !== 1 ? <li className="btn-page-first"><a href={urlParams + '&page=1'}><FeatherIcon icon="chevrons-left" className="nd-icon" /></a></li> : null}
              {startNum - 1 > 0 ? <li className="btn-page-prev"><a href={urlParams + '&page=' + (startNum - 1)}><FeatherIcon icon="chevron-left" className="nd-icon" /></a></li> : null}
              {rendering()}
              {endNum !== totalPages ? <li className="btn-page-next"><a href={urlParams + '&page=' + (startNum + 10)}><FeatherIcon icon="chevron-right" className="nd-icon" /></a></li> : null}
              {curPageNum !== totalPages ? <li className="btn-page-last"><a href={urlParams + '&page=' + totalPages}><FeatherIcon icon="chevrons-right" className="nd-icon" /></a></li> : null}
            </ul>
          </div>
        );
      }
      return <></>;
    }

    function AvgScore(props) {
      let avg = 0;
      const scoreInfo = props.scoreInfo;
      if (scoreInfo.reviewCount > 0) {
        avg = parseFloat((scoreInfo.goodsPtSum / scoreInfo.reviewCount / 20).toFixed(2));
      }
      return avg;
    }

    const hasActiveFilters = !!(this.searchParams.keyword || this.searchParams.category || this.searchParams.overReviewCount);
    const categoryNameById = (id) => {
      const f = (this.categories || []).find(c => String(c.category_no) === String(id));
      return f ? f.category_name : '';
    };
    const reviewCountLabel = {
      '1':'리뷰 1개 이상','5':'리뷰 5개 이상','10':'리뷰 10개 이상','30':'리뷰 30개 이상',
      '50':'리뷰 50개 이상','100':'리뷰 100개 이상','500':'리뷰 500개 이상','1000':'리뷰 1000개 이상'
    };

    return (
      <div className="main-content">
        <PageTitle />

        <div className="review-write-box reviewwrite-redesign">
          {/* 안내 배너 */}
          <div className="section-box" style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '4px 0' }}>
              <FeatherIcon icon="info" size="18" style={{ color: '#4A6CF7' }} />
              <div>
                <strong style={{ fontSize: 14, color: '#16202D' }}>상품별 리뷰 작성 설정</strong>
                <div style={{ fontSize: 12, color: '#74788D', marginTop: 2 }}>
                  특정 상품에서 리뷰 작성을 차단하거나 다시 허용할 수 있습니다. 차단 시 고객이 해당 상품의 리뷰를 작성할 수 없습니다.
                </div>
              </div>
            </div>
          </div>

          {/* === 인라인 필터 바 (reviewWrite 공유) === */}
          <div className="rw-filter-bar">
            <div className="rw-filter-row">
              <FormSelect name="category"
                          value={this.searchParams.category}
                          onChange={(e) => this.onChangeSearchValue(e)}
                          className="rw-filter-category"
                          aria-label="카테고리 필터">
                <option value="">전체 카테고리</option>
                {this.categories && this.categories.map((item, i) => (
                  <option key={i} value={item.category_no}>{item.category_name}</option>
                ))}
              </FormSelect>

              <div className="rw-filter-search">
                <FeatherIcon icon="search" size="14" aria-hidden="true" className="rw-filter-search-icon" />
                <input
                  type="text"
                  name="keyword"
                  placeholder="상품명 검색..."
                  value={this.searchParams.keyword}
                  onChange={(e) => this.onChangeSearchValue(e)}
                  onKeyDown={(e) => { if (e.keyCode === 13) this.search(); }}
                  className="rw-filter-search-input"
                  aria-label="상품명 검색"
                />
                {this.searchParams.keyword && (
                  <button type="button" className="rw-filter-search-clear"
                          onClick={() => this.clearSearchFilter('keyword')}
                          aria-label="검색어 지우기">
                    <FeatherIcon icon="x" size="12" />
                  </button>
                )}
              </div>

              <FormSelect name="overReviewCount"
                          value={this.searchParams.overReviewCount}
                          onChange={(e) => this.onChangeSearchValue(e)}
                          className="rw-filter-count"
                          aria-label="리뷰 수 필터">
                <option value="">리뷰 수 전체</option>
                <option value="1">1개 이상</option>
                <option value="5">5개 이상</option>
                <option value="10">10개 이상</option>
                <option value="30">30개 이상</option>
                <option value="50">50개 이상</option>
                <option value="100">100개 이상</option>
                <option value="500">500개 이상</option>
                <option value="1000">1000개 이상</option>
              </FormSelect>

              <button type="button" className="rw-filter-search-btn"
                      onClick={() => this.search()}
                      aria-label="검색">
                <FeatherIcon icon="search" size="13" aria-hidden="true" />
                검색
              </button>
            </div>

            {hasActiveFilters && (
              <div className="rw-filter-chips">
                <span className="rw-chips-label">
                  <FeatherIcon icon="filter" size="11" aria-hidden="true" />
                  활성 필터
                </span>
                {this.searchParams.category && (
                  <span className="rw-chip">
                    카테고리: <strong>{categoryNameById(this.searchParams.category)}</strong>
                    <button type="button" onClick={() => this.clearSearchFilter('category')} aria-label="카테고리 필터 해제">
                      <FeatherIcon icon="x" size="11" />
                    </button>
                  </span>
                )}
                {this.searchParams.keyword && (
                  <span className="rw-chip">
                    검색: <strong>{this.searchParams.keyword}</strong>
                    <button type="button" onClick={() => this.clearSearchFilter('keyword')} aria-label="검색어 필터 해제">
                      <FeatherIcon icon="x" size="11" />
                    </button>
                  </span>
                )}
                {this.searchParams.overReviewCount && (
                  <span className="rw-chip">
                    {reviewCountLabel[this.searchParams.overReviewCount]}
                    <button type="button" onClick={() => this.clearSearchFilter('overReviewCount')} aria-label="리뷰 수 필터 해제">
                      <FeatherIcon icon="x" size="11" />
                    </button>
                  </span>
                )}
                <button type="button" className="rw-chips-reset" onClick={() => this.resetSearchFilters()}>
                  전체 초기화
                </button>
              </div>
            )}
          </div>

          <div className="section-box">
            <div className="product-list-box">
              <div className="product-pick-list">
                <div className="pick-list-count">
                  총 <span>{this.list && this.list.totalDocs ? this.list.totalDocs : 0}</span>개
                </div>
              </div>
              <table>
                <colgroup>
                  <col width="88px" />
                  <col width="" />
                  <col width="14%" />
                  <col width="24%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>이미지</th>
                    <th>상품 이름</th>
                    <th>리뷰수</th>
                    <th>설정</th>
                  </tr>
                </thead>
                <tbody>
                  {this.list && this.list.docs && this.list.docs.length > 0 ?
                    this.list.docs.map((item, i) => {
                      const disabled = !!(item.vr_productReviewConfig && item.vr_productReviewConfig.isReviewWriteDisabled);
                      const domain = this.teamUser.shop && this.teamUser.shop.primaryDomain
                        ? this.teamUser.shop.primaryDomain
                        : (this.store.platformId + '.cafe24.com');
                      const urlType = (this.teamUser.basicSettings && this.teamUser.basicSettings.productDetailUrlType) || 'easy';
                      const productUrl = urlType === 'basic'
                        ? '//' + domain + '/product/detail.html?product_no=' + item.platformProductId
                        : '//' + domain + '/product/' + item.productName + '/' + item.platformProductId;
                      return (
                        <tr key={i}>
                          <td>
                            <div className="product-thumb"><img src={item.images ? item.images.s_1 : ''} alt="" /></div>
                          </td>
                          <td className="left">
                            <div className="product-title">
                              <a href={productUrl}
                                target='_blank' rel="noopener noreferrer">{item.productName}</a>
                            </div>
                            {disabled && (
                              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 6, padding: '2px 8px', background: '#FEE2E2', color: '#991B1B', borderRadius: 100, fontSize: 11, fontWeight: 700 }}>
                                <FeatherIcon icon="slash" size="11" /> 리뷰 작성 차단됨
                              </div>
                            )}
                          </td>
                          {item.scoreInfo ?
                            <td className="review-count left">
                              <div className="review-normal">
                                일반리뷰 : {item.scoreInfo.reviewCount} / 평점 : <AvgScore scoreInfo={item.scoreInfo} />
                              </div>
                            </td>
                            : <td>-</td>
                          }
                          <td>
                            <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, margin: 0, cursor: 'pointer' }}>
                              <FormCheckbox toggle small
                                checked={!disabled}
                                onChange={() => this.toggleReviewWriteDisabled(item)}>
                                {disabled ? '리뷰 작성 불가' : '리뷰 작성 가능'}
                              </FormCheckbox>
                            </label>
                          </td>
                        </tr>
                      );
                    })
                    :
                    <tr>
                      <td colSpan={4} style={{ padding: '40px 0', textAlign: 'center', color: '#94A3B8' }}>
                        {this.isLoading ? '불러오는 중...' : '상품이 없습니다.'}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              <Pagination />
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default ReviewWriteConfigByProduct;
